var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',[_c('p',{staticClass:"foot-copyright"},[_vm._v("备案许可："),_c('a',{attrs:{"href":"javascript:;"}},[_c('img',{attrs:{"src":require("../img/footer/ba.png?v=2.2.7")}}),_vm._v("京ICP备13044591号-6")])])]),_c('div',[_vm._v("\n        网络视听许可证：0109385号  京ICP证140531号\n    ")])])
}]

export { render, staticRenderFns }